import { Button, Form, Input, Select, message } from 'antd'
import { useEffect, useState } from 'react'
import {
    fetchEpics,
    fetchSprints,
    fetchTags,
    getCurrentProjectId,
    isValidArray,
    isValidObject,
    useAsyncSelect,
} from '../../forms/helper'
// import {
//     createTestCase,
//     updateTestCase,
// } from '../../../../redux/testCases/testCase.service'
// import CreateTagForm from './CreateTagForm'
// import { SprintCreateIcon } from '../../../../../../assets/icons'
import { useDispatch, useSelector } from 'react-redux'
import { SprintCreateIcon } from '../../../../../../../assets/icons'
import {
    setFilter,
    testCaseState,
} from '../../../../../redux/testCases/testCaseList.slice'
import AsyncTagField from './AsyncTagField'
// import {
//     testCaseDetail,
//     testCaseState,
// } from '../../../../redux/testCases/testCaseList.slice'
// import SkeletonTestCaseForm from './SkeletonTestCaseForm'

const { TextArea } = Input

function FilterForm(props) {
    const {
        stateTestCase = {},
        setStateTestCase = () => {},
        handleTestCaseList = () => {},
        handleClose = () => {},
    } = props

    const [form] = Form.useForm()
    const dispatch = useDispatch()

    const { filter, defaultFilter } = useSelector(testCaseState)

    const [submitType, setSubmitType] = useState('close')
    const [isCreateTag, setCreateTag] = useState(false)
    const [saveLoading, setSaveLoading] = useState({
        saveAndNext: false,
        saveAndClose: false,
    })
    console.log('Log ==>filter', filter)
    const isEdit = stateTestCase?.action === 'edit'
    const activeId = stateTestCase?.activeId || ''

    // hook up 3 async selects
    const epicSelect = useAsyncSelect(fetchEpics)
    const sprintSelect = useAsyncSelect(fetchSprints)
    const tagSelect = useAsyncSelect(fetchTags)

    const handleSubmit = async (values) => {
        setSaveLoading({
            saveAndClose: submitType === 'close',
            saveAndNext: submitType === 'next',
        })

        console.log('Log ==>submit values', values, epicSelect)
        const selectedEpic = epicSelect?.options?.filter((item) =>
            values?.epic?.includes(item?.value)
        )
        const selectedSprint = sprintSelect?.options?.find(
            (item) => item?.value === (values?.sprint?.value || values?.sprint)
        )
        const selectedTags = tagSelect?.options?.filter((item) =>
            values?.tags?.includes(item?.value)
        )
        console.log('Log ==>values?.tags', values?.tags)
        dispatch(
            setFilter({
                epic: isValidObject(selectedEpic) ? selectedEpic : '',
                sprint: isValidObject(selectedSprint) ? selectedSprint : '',
                tags: isValidArray(values?.tags) ? values?.tags : [],
            })
        )

        setTimeout(() => {
            setStateTestCase({
                ...stateTestCase,
                filterDrawer: false,
            })
            setSaveLoading({
                saveAndClose: false,
                saveAndNext: false,
            })
        }, 500)
    }

    const handleClear = () => {
        form.setFieldsValue({
            sprint: null,
            tags: [],
        })
        dispatch(setFilter(defaultFilter))
        // setStateTestCase({
        //     ...stateTestCase,
        //     filterDrawer: false,
        // })
    }

    useEffect(() => {
        form.setFieldsValue({
            // epic: filter?.epic || [],
            sprint: filter?.sprint || null,
            tags: filter?.tags || [],
        })
    }, [stateTestCase, filter])

    const getOptionsForMulti = (option) => {
        if (isValidArray(option)) {
            const finalData = option?.map((item) => {
                return {
                    label: item?.name || '',
                    value: item?._id || '',
                }
            })
            return finalData
        }
        return []
    }

    const isShowForm = true
    const testCaseDetailData = {}
    return (
        <div
            style={{
                maxWidth: 700,
                margin: '0 auto',
                paddingLeft: '20px',
                paddingRight: '20px',
                paddingTop: '20px',
                background: '#fff',
                borderRadius: '8px',
            }}
        >
            {/* {testCaseDetailLoading && isEdit && <SkeletonTestCaseForm />} */}
            {isShowForm && (
                <>
                    <Form
                        form={form}
                        layout="horizontal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        labelAlign="left"
                        onFinish={handleSubmit}
                        initialValues={{
                            sprint: filter?.sprint || null,
                            epic: filter?.epic || [],
                            tags: filter?.tags || [],
                        }}
                    >
                        {/* EPIC */}
                        {/* <Form.Item
                            label="Epic"
                            name="epic"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please select an Epic',
                                },
                            ]}
                            style={{ marginBottom: 16 }}
                        >
                            <Select
                                className="test-rail-select"
                                mode="multiple"
                                allowClear
                                showSearch
                                placeholder="Search & select Epic"
                                filterOption={false}
                                onSearch={epicSelect.onSearch}
                                // onDropdownVisibleChange={
                                //     epicSelect.onDropdownVisibleChange
                                // }
                                onOpenChange={
                                    epicSelect.onDropdownVisibleChange
                                }
                                defaultValue={
                                    isEdit
                                        ? getOptionsForMulti(
                                              isValidArray(
                                                  testCaseDetailData?.epic
                                              )
                                                  ? testCaseDetailData?.epic
                                                  : []
                                          )
                                        : []
                                }
                                onChange={(epicIds) => {
                                    form.setFieldValue('epic', epicIds)
                                }}
                                onPopupScroll={epicSelect.onPopupScroll}
                                options={epicSelect.options}
                                loading={epicSelect.loading}
                                notFoundContent={epicSelect.notFoundContent}
                                optionLabelProp="label"
                            />
                        </Form.Item> */}

                        {/* SPRINT */}
                        <Form.Item
                            label="Sprint"
                            name="sprint"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please select a Sprint',
                                },
                            ]}
                            style={{ marginBottom: 16 }}
                        >
                            <Select
                                allowClear
                                showSearch
                                className="reports_project_selecter"
                                placeholder="Search & select Sprint"
                                filterOption={false}
                                onSearch={sprintSelect.onSearch}
                                onOpenChange={
                                    sprintSelect.onDropdownVisibleChange
                                }
                                onPopupScroll={sprintSelect.onPopupScroll}
                                options={sprintSelect.options}
                                loading={sprintSelect.loading}
                                notFoundContent={sprintSelect.notFoundContent}
                                optionLabelProp="label"
                                // fieldNames={{ label: 'title', value: '_id' }}
                            />
                        </Form.Item>

                        {/* <Form.Item
                            label="Tags"
                            name="tags"
                            rules={[
                                {
                                    required: false,
                                    message: 'Please select at least one Tag',
                                },
                            ]}
                            style={{ marginBottom: 16 }}
                        >
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    placeholder="Search & select Tags"
                                    filterOption={false}
                                    onSearch={tagSelect.onSearch}
                                    onOpenChange={
                                        tagSelect.onDropdownVisibleChange
                                    }
                                    // fieldNames={{ label: 'name', value: '_id' }}
                                    defaultValue={
                                        isEdit
                                            ? getOptionsForMulti(
                                                  isValidArray(
                                                      testCaseDetailData?.tags
                                                  )
                                                      ? testCaseDetailData?.tags
                                                      : []
                                              )
                                            : []
                                    }
                                    onChange={(tagIds) => {
                                        form.setFieldValue('tags', tagIds)
                                    }}
                                    // value={form.getFieldValue('tags')}
                                    onPopupScroll={tagSelect.onPopupScroll}
                                    options={tagSelect.options}
                                    loading={tagSelect.loading}
                                    notFoundContent={tagSelect.notFoundContent}
                                    optionLabelProp="label"
                                />
                               
                            </div>
                        </Form.Item> */}

                        <AsyncTagField
                            form={form}
                            creatable={false}
                            rules={[
                                {
                                    required: false,
                                    message: 'Please choose at least one item',
                                },
                            ]}
                        />

                        {/* Sticky actions */}
                        <div
                            style={{
                                position: 'sticky',
                                bottom: 0,
                                background: '#fff',
                                padding: '10px 0',
                                borderTop: '1px solid #f0f0f0',
                                width: '100%',
                                zIndex: 99,
                                marginTop: 20,
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                    width: '100%',
                                    gap: '10px',
                                }}
                            >
                                <Button
                                    type="default"
                                    htmlType="submit"
                                    loading={saveLoading?.saveAndClose}
                                    onClick={() => setSubmitType('close')}
                                >
                                    Save
                                </Button>
                                <Button
                                    type="default"
                                    htmlType="button"
                                    loading={false}
                                    onClick={handleClear}
                                >
                                    Clear
                                </Button>

                                <Button
                                    type="default"
                                    htmlType="button"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Form>
                </>
            )}
        </div>
    )
}

export default FilterForm
